var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBear2X = function SvgBear2X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 5.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78831803,-5.64574007 C5.62186063,-5.44139926 7.31542117,-2.15055322 10.8689996,4.22679805 C7.31542117,10.6052973 5.62128664,13.8961433 5.78659606,14.0993362 C5.89795032,14.238242 8.71056039,10.9466059 14.2244263,4.22442777 C8.76566353,-2.56002493 5.95362745,-5.85008087 5.78831803,-5.64574007 Z",
    transform: "translate(10.000000, 4.224426) rotate(90.000000) translate(-10.000000, -4.224426) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78831803,-0.645740065 C5.62186063,-0.441399258 7.31542117,2.84944678 10.8689996,9.22679805 C7.31542117,15.6052973 5.62128664,18.8961433 5.78659606,19.0993362 C5.89795032,19.238242 8.71056039,15.9466059 14.2244263,9.22442777 C8.76566353,2.43997507 5.95362745,-0.850080873 5.78831803,-0.645740065 Z",
    transform: "translate(10.000000, 9.224426) rotate(90.000000) translate(-10.000000, -9.224426) "
  }))));
};
export { SvgBear2X as ReactComponent };